import React from 'react';

import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, ArcElement, Title, Tooltip, Legend } from "chart.js";
import { Doughnut, Bar } from 'react-chartjs-2';

function SummaryPage(props) {

    let items = [];

    ChartJS.register(CategoryScale, LinearScale, BarElement, ArcElement, Title, Tooltip, Legend);

    let indexByLevel = {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
    };

    // Build Index
    let i = 0;
    for (i = 0; i < props.Index.Records.length; i++)
    {
        let r = props.Index.Records[i];

        indexByLevel[r.Level]++;
    }

    let doughnutdata = {
        labels: ['Critical', 'Errors', 'Warning', 'Info'],
        datasets: [
          {
            label: '# of entries',
            data: [
                indexByLevel["1"],
                indexByLevel["2"],
                indexByLevel["3"],
                indexByLevel["4"]
            ],
            backgroundColor: [
              'rgba(211, 33, 45, 0.5)',
              'rgba(255, 126, 0, 0.5)',
              'rgba(124, 185, 232, 0.5)',
              'rgba(176, 191, 26, 0.5)'
            ],
            borderColor: [
              'rgba(211, 33, 45, 1)',
              'rgba(255, 126, 0, 1)',
              'rgba(124, 185, 232, 1)',
              'rgba(176, 191, 26, 1)'
            ],
            borderWidth: 1,
          },
        ],
      };

    items.push(<div className="mt-4" key={items.length}>Levels</div>)
    items.push(<Doughnut key={items.length} className="chartblock-1" data={doughnutdata}/>)

    //=================================

    let histogram = {};
    let min_dt = 0;
    let max_dt = 0;

    // Build Histogram
    for (i = 0; i < props.Index.Index.length; i++)
    {
        if (props.Index.Index[i].Name === "Date x Time")
        {
            let idx = props.Index.Index[i].Index;

            Object.keys(idx).forEach((d) => {
                Object.keys(idx[d]).forEach((t) =>
                {
                    let item = idx[d][t];

                    for (let n = 0; n < item.length; n++)
                    {
                        let r = props.Index.Records[n];
                        //console.log("VL:", r);

                        let dt = new Date(d + " " + t);
                        dt.setMinutes(0);
                        dt.setSeconds(0);
                        dt.setMilliseconds(0);

                        if (min_dt === 0)
                        {
                            min_dt = dt;
                            max_dt = dt;
                        }
                        else
                        {
                            max_dt = Math.max(dt, max_dt);
                            min_dt = Math.min(dt, min_dt);
                        }

                        let hist = histogram[dt.getTime()];
                        if (!hist)
                        {
                            hist = {
                                L1: 0,
                                L2: 0,
                                L3: 0,
                                L4: 0
                            };

                            histogram[dt.getTime()] = hist;
                        }

                        switch (r.Level)
                        {
                            case "1":
                                hist.L1++;
                                break;

                            case "2":
                                hist.L2++;
                                break;

                            case "3":
                                hist.L3++;
                                break;

                            case "4":
                                hist.L4++;
                                break;
                        }
                    }
                });
            });

            break;
        }
    }
    
    console.log("VL1:", min_dt, max_dt, histogram);

    // Get labels
    let label = [];
    let l1 = [];
    let l2 = [];
    let l3 = [];
    let l4 = [];

    for (let ts = min_dt; ts <= max_dt; ts+= 60*60*1000)
    {
        let dt = new Date(ts);
        let disp = dt.getMonth()+1 + "/" + dt.getDate() + " " + dt.getHours() + ":00";

        label.push(disp);
        let hist = histogram[ts];
        if (hist)
        {
            l1.push(hist.L1);
            l2.push(hist.L2);
            l3.push(hist.L3);
            l4.push(hist.L4);
        }
        else
        {
            l1.push(0);
            l2.push(0);
            l3.push(0);
            l4.push(0);
        }
    }

    let options = {
        scales: {
            x: {
                stacked: true
            },
            y: {
                stacked: true
            }
        }
    }

    let bardata = {
        labels: label,
        datasets: [
            // {
            //     label: 'Info',
            //     data: l4,
            //     backgroundColor: 'rgba(176, 191, 26, 0.5)'
            // },
            {
                label: 'Warning',
                data: l3,
                backgroundColor: 'rgba(124, 185, 232, 0.5)'
            },
            {
                label: 'Error',
                data: l2,
                backgroundColor: 'rgba(255, 126, 0, 0.5)'
            },
            {
                label: 'Critical',
                data: l1,
                backgroundColor: 'rgba(211, 33, 45, 0.5)'
            }
        ]
    }

    items.push(<div key={items.length}>Levels over Time</div>)
    items.push(<Bar className="chartblock-1" key={items.length} options={options} data={bardata}/>)

    return (
        <div className="scrollable" style={{ height: (window.innerHeight -60)+"px" }}>
            {items}
        </div>
    );
}

export default SummaryPage;
